import { websocketService } from '@/services/WebsocketService';
import { dedicatedMachineDetailsService } from '@/components/dedicated-machine-edit/services/DedicatedMachineDetailsService';

const state = () => ({
  nics: [],
});

const mutations = {
  setNetworkCards(state: any, nics: any) {
    state.nics = nics;
  },
};

const actions = {
  updateNetworkCard({ commit, state }: any, nic: any = null) {
    if (nic && nic.id) {
      const index = state.nics.findIndex((item: any) => item.id === nic.id);
      if (index !== -1) {
        state.nics[index] = {
          ...state.nics[index],
          ...nic,
        };
      }
      commit('setNetworkCards', [...state.nics]);
    }
  },
  getNetworkCards({ commit, state, rootState }: any, isForced: boolean = false) {
    return new Promise(resolve => {
      if (state.nics && state.nics.length > 0 && !isForced && websocketService.isConnected) {
        resolve(state.nics);
      } else {
        dedicatedMachineDetailsService
          .getAllNetworkCards(rootState.currentWorkspace.id, rootState.currentWorkspace.currentRegionId)
          .then((data: any) => {
            commit('setNetworkCards', data);
            resolve(data);
          });
      }
    });
  },
};

const getters = {
  getDedicatedMachineNics: (state: any, getters: any, rootState: any) => (id: number) => {
    return state.nics ? state.nics.filter((item: any) => item.dm_reservation && id === item.dm_reservation.id) : [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
